<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento médico">
            <template
                v-if="loaded"
                v-slot:center
            >
                <rkm-button
                    v-if="model.dorToracica"
                    color="warning"
                >
                    Dor torácica
                </rkm-button>

                <rkm-button
                    v-if="model.alergias.length > 0"
                    @click="scrollToAlergias"
                    color="alergia"
                >
                    Paciente Alérgico
                </rkm-button>
            </template>

            <template
                v-if="loaded"
                v-slot:actions
            >
                <rkm-button
                    @click.stop="exit()"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="!additionals.fromObservacao || model.proximaReavaliacao === false"
                    @click="handleDesfecho()"
                    color="btn btn-outline-success"
                >
                    Desfecho
                </rkm-button>

                <rkm-button
                    v-if="!additionals.fromObservacao || model.proximaReavaliacao === true"
                    @click="$refs.Form.handleDesfecho()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="form.paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="form.paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ form.paciente.nome }} <strong>({{ form.paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ form.paciente.nome }},
                    </span>
                    <span v-if="form.paciente.idade">
                        {{ form.paciente.idade.anos }} anos,
                        {{ form.paciente.idade.meses }} meses
                        e {{ form.paciente.idade.dias }} dias,
                    </span>
                    <span>{{ form.paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content v-if="loaded">
                <Form
                    ref="Form"
                    :plantao-id="$route.params.plantaoId"
                    :data="{ form, model, additionals }"
                    @save="redirectToList()"
                />

                <ModalFinalizarAtendimento
                    :plantao-id="$route.params.plantaoId"
                    :data="{ form, model, additionals }"
                    @click-to-save="$refs.Form.save()"
                    @save="redirectToList()"
                    ref="ModalFinalizarAtendimento"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Components.
import Form from '@/components/pronto-atendimento/atendimento-medico/Form'
import ModalFinalizarAtendimento from '@/components/pronto-atendimento/atendimento-medico/components/finalizar-atendimento/Modal'

// Enums.
import statusExame from '@/enums/pronto-atendimento/statusExame'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

import moment from 'moment'

export default {
    components: { Form, ModalFinalizarAtendimento },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            atendimentoMedico: this.getConectaSusRepository('prontoAtendimento.atendimentoMedico'),
            fila: this.getConectaSusRepository('prontoAtendimento.fila')
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {},
        additionals: {},
        enums: { statusExame, preferenciaNome },
        loaded: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        load() {

            this.setLoading()

            this.repositories.atendimentoMedico.create(this.$route.params.id)
                .then(response => {

                    response.data.model.dataProximaReavaliacao = moment(
                        response.data.model.dataProximaReavaliacao,
                        'DD/MM/YYYY'
                    ).toDate()

                    response.data.form.declaracoesComparecimento.map(declaracao => {

                        declaracao.dataDe = moment(declaracao.dataDe, 'DD/MM/YYYY').toDate()
                        declaracao.dataAte = moment(declaracao.dataAte, 'DD/MM/YYYY').toDate()
                    })

                    this.form = response.data.form
                    this.model = response.data.model
                    this.additionals = response.data.additionals
                    this.model.filaId = this.$route.params.id
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        scrollToAlergias() {

            const element = document.querySelector('#alergias')

            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        },
        exit() {

            this.showExitConfirmation(async () => {

                this.setLoading()

                return this.repositories.fila.sendBack(this.$route.params.id)
                    .then(() => this.redirectToList())
                    .finally(() => this.unsetLoading())
            }, this.handleError)
        },
        redirectToList() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({
                name: this.additionals.fromObservacao
                    ? 'pronto-atendimento-paciente-observacao-index'
                    : 'pronto-atendimento-atendimento-medico-index'
            }).catch(() => {})
        },
        async handleDesfecho() {

            if (this.additionals.fromObservacao) {

                this.$refs.ModalFinalizarAtendimento.open()

                return
            }

            if (this.hasSolicitacaoExameNaoRealizada()) {

                this.showSolicitacaoExamesConfirmation(() => {

                    if (this.hasPrescricaoInternaNaoRealizada()) {

                        this.$nextTick().then(() => {

                            this.showPrescricaoInternaConfirmation(() => {

                                if (this.hasServicoEnfermagemNaoRealizado()) {

                                    this.$nextTick().then(() => {

                                        this.showServicoEnfermagemConfirmation(() => {

                                            this.$refs.ModalFinalizarAtendimento.open()
                                        })
                                    })
                                }
                                else {

                                    this.$refs.ModalFinalizarAtendimento.open()
                                }
                            })
                        })
                    }
                    else if (this.hasServicoEnfermagemNaoRealizado()) {

                        this.$nextTick().then(() => {

                            this.showServicoEnfermagemConfirmation(() => {

                                this.$refs.ModalFinalizarAtendimento.open()
                            })
                        })
                    }
                    else {

                        this.$refs.ModalFinalizarAtendimento.open()
                    }
                })
            }
            else if (this.hasPrescricaoInternaNaoRealizada()) {

                this.showPrescricaoInternaConfirmation(() => {

                    if (this.hasServicoEnfermagemNaoRealizado()) {

                        this.$nextTick().then(() => {

                            this.showServicoEnfermagemConfirmation(() => {

                                this.$refs.ModalFinalizarAtendimento.open()
                            })
                        })
                    }
                    else {

                        this.$refs.ModalFinalizarAtendimento.open()
                    }
                })
            }
            else if (this.hasServicoEnfermagemNaoRealizado()) {

                this.showServicoEnfermagemConfirmation(() => {

                    this.$refs.ModalFinalizarAtendimento.open()
                })
            }
            else {

                this.$refs.ModalFinalizarAtendimento.open()
            }
        },
        showSolicitacaoExamesConfirmation(callback) {

            this.showConfirmation(
                'Há um ou mais exames solicitados. Se continuar com o desfecho, '
                    + 'não será possível realizar o exame. Deseja realmente continuar?',
                async () => callback()
            )
        },
        showPrescricaoInternaConfirmation(callback) {

            this.showConfirmation(
                'Há uma ou mais prescrições interna solicitadas. Se continuar com o desfecho, '
                    + 'não será possível atender a prescrição. Deseja realmente continuar?',
                async () => callback()
            )
        },
        showServicoEnfermagemConfirmation(callback) {

            this.showConfirmation(
                'Há um ou mais serviços de enfermagem solicitados. Se continuar com o desfecho, '
                    + 'não será possível atender ao serviço. Deseja realmente continuar?',
                async () => callback()
            )
        },
        hasSolicitacaoExameNaoRealizada() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.pedidosExames.concat(this.model.pedidosExames)
                .find(p => p.exames.find(e => !e.status || !status.includes(e.status.id)))
        },
        hasPrescricaoInternaNaoRealizada() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.prescricoesInternas.concat(this.model.prescricoesInternas).find(p => p.medicamentos
                .find(m => !m.aplicacoes || m.aplicacoes.find(a => !status.includes(a.status.id))))
        },
        hasServicoEnfermagemNaoRealizado() {

            const status = [this.enums.statusExame.REALIZADO, this.enums.statusExame.NAO_REALIZADO]

            return !!this.form.servicosEnfermagem.concat(this.model.servicosEnfermagem)
                .find(s => !status.includes(s.status.id))
        },
    },
    mixins: [error, repository],
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>